import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Lux_Title } from '../../../../../utils/ES/Modals/SpotsModals';

const ModlaLux = () => {
  return (
    <>
      <ModalVideo
        id="spot-lux"
        dataText={Lux_Title}
        videoSrc="https://player.vimeo.com/video/716232913?h=d563db7d03&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_LUX"
      />
    </>
  );
};

export default ModlaLux;
